const htmlTemplateForm = () => {
    const calculatorWrp = document.getElementById('calculator-rent-buy');

    if(!calculatorWrp) {
        return false;
    }

    const html = `
    <form id="calculatorRentVsBuy" name="calculatorRentBuy" class="calc-wrp">
        <section class="calc-wrp__container">
            <div class="calculator">
                <div class="form-wrp">
                    <div class="form-wrp__line">
                        <div class="form-wrp__inner-line">
                            <div class="form-wrp__item">
                                <h3 class="form-wrp__header">Rental information</h3>
                                <label for="monthly-rent" class="form-wrp__label">
                                    Monthly rent, $
                                </label>
                                <input type="number"
                                       class="input"
                                       min="0"
                                       step="100"
                                       name="monthly-rent"
                                       placeholder="1000"
                                       value="2000"
                                       id="monthly-rent">
                            </div>
                            <div class="form-wrp__item">
                                <label for="annual-rent-increase" class="form-wrp__label">
                                    Annual rent increase, %
                                </label>
                                <input type="number"
                                       class="input"
                                       min="0"
                                       step="0.1"
                                       value="4.0"
                                       name="annual-rent-increase"
                                       placeholder="4.00"
                                       id="annual-rent-increase">
                            </div>

                            <div class="form-wrp__item">
                                <div class="switcher-parent">
                                    <label class="switcher-label" for="switch-rental-insurance-currency">
                                        <input type="radio"
                                               name="switch-rental-insurance"
                                               data-target="rental-insurance"
                                               value="$"
                                               class="switcher"
                                               id="switch-rental-insurance-currency"
                                               checked="checked">
                                        <div class="radio-icon">$</div>
                                    </label>
                                    <label class="switcher-label" for="switch-rental-insurance-percent">
                                        <input type="radio"
                                               name="switch-rental-insurance"
                                               data-target="rental-insurance"
                                               value="%"
                                               class="switcher"
                                               id="switch-rental-insurance-percent">
                                        <div class="radio-icon">%</div>
                                    </label>
                                </div>
                                <label for="annual-rent-increase" class="form-wrp__label">
                                    Monthly rent insurance
                                </label>
                                <input type="number"
                                       class="input"
                                       min="0"
                                       step="1"
                                       value="100"
                                       name="rental-insurance"
                                       placeholder="100"
                                       id="rent-insurance">
                            </div>
                        </div>
                    </div>
                    <div class="form-wrp__line">
                        <div class="form-wrp__inner-line">
                            <div class="form-wrp__item">
                                <h3 class="form-wrp__header">Property information</h3>
                                <label for="home-value" class="form-wrp__label">
                                    Home value, $
                                </label>
                                <input type="number"
                                       class="input"
                                       min="0"
                                       step="1000"
                                       name="home-value"
                                       placeholder="300000"
                                       value="300000"
                                       id="home-value">
                            </div>
                            <div class="form-wrp__item">
                                <label for="annual-maintenance" class="form-wrp__label">
                                    Annual maintenance, $
                                </label>
                                <input type="number"
                                       class="input"
                                       min="0"
                                       step="100"
                                       value="1000"
                                       name="annual-maintenance"
                                       placeholder="1000"
                                       id="annual-maintenance">
                            </div>
                            <div class="form-wrp__item">
                                <label for="annual-appreciation" class="form-wrp__label">
                                    Annual appreciation, %
                                </label>
                                <input type="number"
                                       class="input"
                                       min="0"
                                       step="0.1"
                                       value="5.0"
                                       name="annual-appreciation"
                                       placeholder="5.00"
                                       id="annual-appreciation">
                            </div>
                            <div class="form-wrp__item">
                                <label for="years-before" class="form-wrp__label">
                                    Years before sell
                                </label>
                                <input type="number"
                                       class="input"
                                       min="1"
                                       step="1"
                                       value="5"
                                       name="years-before"
                                       placeholder="5"
                                       id="years-before">
                            </div>
                            <div class="form-wrp__item">
                                <label for="selling-cost" class="form-wrp__label">
                                    Selling cost, %
                                </label>
                                <input type="number"
                                       class="input"
                                       min="0"
                                       step="0.5"
                                       value="6"
                                       name="selling-cost"
                                       placeholder="7.00"
                                       id="selling-cost">
                            </div>
                            <div class="form-wrp__item">
                                <label for="hoa-dues" class="form-wrp__label">Annual HOA dues</label>
                                <input type="number"
                                       class="input"
                                       name="hoa-dues"
                                       placeholder="0"
                                       value="0"
                                       step="100"
                                       min="0"
                                       id="hoa-dues">
                            </div>
                        </div>
                    </div>

                    <div class="form-wrp__line">
                        <div class="form-wrp__inner-line">
                            <div class="form-wrp__item">
                                <h3 class="form-wrp__header">Loan information</h3>
                                <label for="amount" class="form-wrp__label">
                                    Amount, $
                                </label>
                                <input type="number"
                                       class="input"
                                       min="0"
                                       step="1000"
                                       name="amount"
                                       placeholder="270000"
                                       value="270000"
                                       id="amount">
                            </div>
                            <div class="form-wrp__item">
                                <label for="interest-rate" class="form-wrp__label">
                                    Interest Rate, %
                                </label>
                                <input type="number"
                                       class="input"
                                       min="0"
                                       step="0.1"
                                       value="5.75"
                                       name="interest-rate"
                                       placeholder="5.75"
                                       id="interest-rate">
                            </div>
                            <div class="form-wrp__item">
                                <label for="term" class="form-wrp__label">
                                    Length, years
                                </label>
                                <input type="number"
                                       class="input"
                                       min="10"
                                       max="30"
                                       step="5"
                                       value="30"
                                       name="term"
                                       placeholder="30"
                                       id="term">
                            </div>
                            <div class="form-wrp__item">
                                <div class="switcher-parent">
                                    <label class="switcher-label" for="switch-points-currency">
                                        <input type="radio"
                                               name="switch-points"
                                               data-target="points"
                                               value="$"
                                               class="switcher"
                                               id="switch-points-currency"
                                               checked="checked">
                                        <div class="radio-icon">$</div>
                                    </label>
                                    <label class="switcher-label" for="switch-points-percent">
                                        <input type="radio"
                                               name="switch-points"
                                               data-target="points"
                                               value="%"
                                               class="switcher"
                                               id="switch-points-percent">
                                        <div class="radio-icon">%</div>
                                    </label>
                                </div>
                                <label for="points" class="form-wrp__label">
                                    Closing costs
                                </label>
                                <input type="number"
                                       class="input"
                                       min="0"
                                       step="100"
                                       value="10000"
                                       name="points"
                                       placeholder="1.00"
                                       id="points">
                            </div>
                        </div>
                    </div>

                    <div class="form-wrp__line">
                        <h3 class="form-wrp__header">Taxes and insurance information</h3>
                        <div class="form-wrp__inner-line">

                            <div class="form-wrp__item">
                                <label for="your-tax-rate" class="form-wrp__label">
                                    Your income tax rate, %
                                </label>
                                <input type="number"
                                       class="input"
                                       name="your-tax-rate"
                                       placeholder="26.00"
                                       value="25.00"
                                       min="0"
                                       step="1"
                                       id="your-tax-rate">
                            </div>
                            <div class="form-wrp__item">
                                <div class="switcher-parent">
                                    <label class="switcher-label" for="switch-taxes-currency">
                                        <input type="radio"
                                               name="switch-taxes"
                                               data-target="annual-tax"
                                               value="$"
                                               class="switcher"
                                               id="switch-taxes-currency"
                                               checked="checked">
                                        <div class="radio-icon">$</div>
                                    </label>
                                    <label class="switcher-label" for="switch-taxes-percent">
                                        <input type="radio"
                                               name="switch-taxes"
                                               data-target="annual-tax"
                                               value="%"
                                               class="switcher"
                                               id="switch-taxes-percent">
                                        <div class="radio-icon">%</div>
                                    </label>
                                </div>
                                <label for="annual-tax" class="form-wrp__label">
                                    Annual Taxes
                                </label>
                                <input type="number"
                                       class="input"
                                       name="annual-tax"
                                       min="0"
                                       step="1000"
                                       placeholder="1000"
                                       value="7500"
                                       id="annual-tax">
                            </div>

                            <div class="form-wrp__item">
                                <div class="switcher-parent">
                                    <label class="switcher-label" for="switch-insurance-currency">
                                        <input type="radio"
                                               name="switch-insurance"
                                               data-target="annual-insurance"
                                               value="$"
                                               class="switcher"
                                               id="switch-insurance-currency"
                                               checked="checked">
                                        <div class="radio-icon">$</div>
                                    </label>
                                    <label class="switcher-label" for="switch-insurance-percent">
                                        <input type="radio"
                                               name="switch-insurance"
                                               data-target="annual-insurance"
                                               value="%"
                                               class="switcher"
                                               id="switch-insurance-percent">
                                        <div class="radio-icon">%</div>
                                    </label>
                                </div>
                                <label for="annual-insurance" class="form-wrp__label">
                                    Annual insurance
                                </label>
                                <div>
                                    <input type="number"
                                           class="input"
                                           value="2000"
                                           placeholder="1500"
                                           min="0"
                                           step="100"
                                           name="annual-insurance"
                                           id="annual-insurance">
                                </div>
                            </div>

                            <div class="form-wrp__item">
                                <div class="switcher-parent">
                                    <label class="switcher-label" for="switch-pmi-currency">
                                        <input type="radio"
                                               name="switch-pmi"
                                               data-target="annual-pmi"
                                               value="$"
                                               class="switcher"
                                               id="switch-pmi-currency">
                                        <div class="radio-icon">$</div>
                                    </label>
                                    <label class="switcher-label" for="switch-pmi-percent">
                                        <input type="radio"
                                               name="switch-pmi"
                                               data-target="annual-pmi"
                                               value="%"
                                               class="switcher"
                                               id="switch-pmi-percent"
                                               checked="checked">
                                        <div class="radio-icon">%</div>
                                    </label>
                                </div>
                                <label for="annual-pmi" class="form-wrp__label">
                                    Annual MI
                                </label>
                                <input type="number"
                                       class="input"
                                       name="annual-pmi"
                                       placeholder="0.50"
                                       min="0"
                                       step="0.1"
                                       value="0.50"
                                       id="annual-pmi">
                            </div>
                        </div>

                        <div class="form-wrp__inner-line">
                            <div class="form-wrp__item">
                                <button id="rerender" type="button" class="calc-wrp__btn-calc">
                                    Calculate now
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="tabs calculator-form">
                        <div class="tabs__nav">
                            <div class="tabs__tab" data-id="1">
                                Financial analysis
                            </div>
                            <div class="tabs__tab" data-id="2">
                                Plain English help
                            </div>
                        </div>

                        <div class="tabs__wrapper inline">
                            <div class="tabs__content" data-id="1">
                                <div class="calculator-form__content">

                                    <!--                                    first-->
                                    <div class="calculator-form__content-wrapper">
                                        <div class="calculator-form__content-box">
                                            <div class="calculator-form__line">
                                                <div class="calculator-form__label">
                                                    <div></div>
                                                </div>
                                                <div class="calculator-form__item title">
                                                    <div>Rent</div>
                                                </div>
                                                <div class="calculator-form__item title">
                                                    <div>Buy</div>
                                                </div>
                                            </div>

                                            <div class="calculator-form__line">
                                                <div class="calculator-form__label">
                                                    <div>
                                                        Total rent or P&I payments, $
                                                    </div>
                                                </div>
                                                <div class="calculator-form__item">
                                                    <!--                                                            <span class="mobile-comment">Before</span>-->
                                                    <div data-calc-result="total-principal-rent">0</div>
                                                </div>
                                                <div class="calculator-form__item">
                                                    <!--                                                            <span class="mobile-comment">After</span>-->
                                                    <div data-calc-result="total-principal-buy">0</div>
                                                </div>
                                            </div>

                                            <div class="calculator-form__line">
                                                <div class="calculator-form__label">
                                                    <div>
                                                        Taxes and insurance, $
                                                    </div>
                                                </div>
                                                <div class="calculator-form__item">
                                                    <!--                                                            <span class="mobile-comment">Before</span>-->
                                                    <div data-calc-result="taxes-insurance-rent">0</div>
                                                </div>
                                                <div class="calculator-form__item">
                                                    <!--                                                            <span class="mobile-comment">After</span>-->
                                                    <div data-calc-result="taxes-insurance-buy">0</div>
                                                </div>
                                            </div>
                                            <div class="calculator-form__line">
                                                <div class="calculator-form__label">
                                                    <div>
                                                        Total Mortgage Insurance, $
                                                    </div>
                                                </div>
                                                <div class="calculator-form__item">
                                                    <!--                                                            <span class="mobile-comment">Before</span>-->
                                                    <div data-calc-result="pmi-rent">0</div>
                                                </div>
                                                <div class="calculator-form__item">
                                                    <!--                                                            <span class="mobile-comment">After</span>-->
                                                    <div data-calc-result="pmi-buy">0</div>
                                                </div>
                                            </div>
                                            <div class="calculator-form__line">
                                                <div class="calculator-form__label">
                                                    <div>
                                                        Total maintenance and HOA dues, $
                                                    </div>
                                                </div>
                                                <div class="calculator-form__item">
                                                    <!--                                                            <span class="mobile-comment">Before</span>-->
                                                    <div data-calc-result="maintenance-rent">0</div>
                                                </div>
                                                <div class="calculator-form__item">
                                                    <!--                                                            <span class="mobile-comment">After</span>-->
                                                    <div data-calc-result="maintenance-buy">0</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="calculator-form__content-wrapper result-block">
                                        <div class="calculator-form__content-box">
                                            <div class="calculator-form__line">
                                                <div class="calculator-form__label result">Total payments</div>
                                                <div class="calculator-form__item-result total"
                                                     data-calc-result="total-payments-rent">
                                                    0
                                                </div>
                                                <div class="calculator-form__item-result total"
                                                     data-calc-result="total-payments-buy">
                                                    0
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!--                                    second-->
                                    <div class="calculator-form__content-wrapper">
                                        <div class="calculator-form__content-box">
                                            <div class="calculator-form__line">
                                                <div class="calculator-form__label">
                                                    <div></div>
                                                </div>
                                                <div class="calculator-form__item title">
                                                    <div>Rent</div>
                                                </div>
                                                <div class="calculator-form__item title">
                                                    <div>Buy</div>
                                                </div>
                                            </div>

                                            <div class="calculator-form__line">
                                                <div class="calculator-form__label">
                                                    <div>
                                                        Average Monthly Payment, $
                                                    </div>
                                                </div>
                                                <div class="calculator-form__item">
                                                    <div data-calc-result="average-monthly-rent">0</div>
                                                </div>
                                                <div class="calculator-form__item">
                                                    <div data-calc-result="average-monthly-buy">0</div>
                                                </div>
                                            </div>
                                            <div class="calculator-form__line">
                                                <div class="calculator-form__label">
                                                    <div>
                                                        Monthly Rent Savings, $
                                                    </div>
                                                </div>
                                                <div class="calculator-form__item full-width">
                                                    <div data-calc-result="monthly-rent-savings">0</div>
                                                </div>
                                            </div>
                                            <div class="calculator-form__line">
                                                <div class="calculator-form__label">
                                                    <div>
                                                        Total income tax savings, $
                                                    </div>
                                                </div>
                                                <div class="calculator-form__item">
                                                    <div data-calc-result="tax-savings-rent">0</div>
                                                </div>
                                                <div class="calculator-form__item">
                                                    <div data-calc-result="tax-savings-buy">0</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="calculator-form__content-wrapper result-block">
                                        <div class="calculator-form__content-box">
                                            <div class="calculator-form__line">
                                                <div class="calculator-form__label result">Total Rent Details</div>
                                                <div class="calculator-form__item-result full-width total"
                                                     data-calc-result="total-rent-savings">
                                                    0
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!--                                    third-->
                                    <div class="calculator-form__content-wrapper">
                                        <div class="calculator-form__content-box">
<!--                                            <div class="calculator-form__line">-->
<!--                                                <div class="calculator-form__label">-->
<!--                                                    <div></div>-->
<!--                                                </div>-->
<!--                                                <div class="calculator-form__item title">-->
<!--                                                    <div>Rent</div>-->
<!--                                                </div>-->
<!--                                                <div class="calculator-form__item title">-->
<!--                                                    <div>Buy</div>-->
<!--                                                </div>-->
<!--                                            </div>-->

                                            <div class="calculator-form__line">
                                                <div class="calculator-form__label">
                                                    <div>
                                                        House Appreciation Value, $
                                                    </div>
                                                </div>
                                                <div class="calculator-form__item full-width">
                                                    <div data-calc-result="house-appreciation-value">0</div>
                                                </div>
                                            </div>
                                            <div class="calculator-form__line">
                                                <div class="calculator-form__label">
                                                    <div>
                                                        Proceeds Minus Selling Costs, $
                                                    </div>
                                                </div>
                                                <div class="calculator-form__item full-width">
                                                    <div data-calc-result="proceeds-minus-costs">0</div>
                                                </div>
                                            </div>
                                            <div class="calculator-form__line">
                                                <div class="calculator-form__label">
                                                    <div>
                                                        Minus Loan Balance, $
                                                    </div>
                                                </div>
                                                <div class="calculator-form__item full-width">
                                                    <div data-calc-result="loan-balance">0</div>
                                                </div>
                                            </div>
                                            <div class="calculator-form__line">
                                                <div class="calculator-form__label">
                                                    <div>
                                                        Recover Initial Down Payment, $
                                                    </div>
                                                </div>
                                                <div class="calculator-form__item full-width">
                                                    <div data-calc-result="equity-appreciation">0</div>
                                                </div>
                                            </div>
                                            <div class="calculator-form__line">
                                                <div class="calculator-form__label">
                                                    <div>
                                                        Recover Loan closing Costs, $
                                                    </div>
                                                </div>
                                                <div class="calculator-form__item full-width">
                                                    <div data-calc-result="closing-cost">0</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="calculator-form__content-wrapper result-block">
                                        <div class="calculator-form__content-box">
                                            <div class="calculator-form__line">
                                                <div class="calculator-form__label result">Home Purchase Benefits</div>
                                                <div class="calculator-form__item-result full-width total"
                                                     data-calc-result="home-purchase-benefits">
                                                    0
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div class="tabs__content" data-id="2">
                                <div class="calculator-form__text-result-wrapper">
                                    <div class="text">
                                        <p>Is it financially better to buy a home or to rent? The answer to this
                                            question depends upon how much the home costs, how much you are
                                            paying
                                            for rent, and how much you will have to pay each year in order to
                                            maintain your home.</p>

                                        <p>If you were to pay <span class="marker currency"
                                                                    data-calc-result="monthly-rent">0</span> per
                                            month,
                                            for example, and the average rental payment increase was
                                            <span class="marker percent"
                                                  data-calc-result="annual-rent-increase">0</span>,
                                            you would pay <span class="marker currency"
                                                                data-calc-result="total-payments-rent">0</span>
                                            in a
                                            <span class="marker" data-calc-result="years-before">0</span> year
                                            period toward rent and insurance.
                                            
                                            If you purchased a home and borrowed <span class="marker currency"
                                                                                       data-calc-result="amount-no-pennies">0</span> 
                                            with a <span class="marker percent"
                                                         data-calc-result="interest-rate">0</span>
                                                          interest rate, 
                                                          and you paid <span class="marker currency"
                                                               data-calc-result="maintenance-buy">0</span> every year toward its maintenance/HOA dues,
                                            you could expect to pay a total amount of <span class="marker currency"
                                                                data-calc-result="total-payments-buy">0</span> in a <span class="marker" data-calc-result="years-before">0</span> year period. 
                                            For property taxes and insurance, you pay <span class="marker currency"
                                                          data-calc-result="annual-tax">0</span> in taxes each year and your annual insurance amount is <span
                                                    class="marker currency"
                                                    data-calc-result="annual-insurance">0</span>.
                                        </p>
                                        <p>
                                            When you consider your tax benefits and the appreciation of your
                                            home,
                                            however, you will actually MAKE money by purchasing a home.
                                            If your home shows an annual appreciation of <span
                                                class="marker percent"
                                                data-calc-result="annual-appreciation">0</span>
                                            and your selling cost is <span class="marker percent"
                                                                           data-calc-result="selling-cost">0</span>,
                                            your house appreciation value will be <span class="marker currency"
                                                                                        data-calc-result="house-appreciation-value">0</span>.
                                            As a result, your total home purchase benefit will amount to <span
                                                class="marker currency"
                                                data-calc-result="home-purchase-benefits">0</span>.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="calc-wrp__btn-box">
                        <button type="button" class="calc-wrp__btn-calc secondary" data-modal="modalSendResult">
                            Send now
                            <svg width="7" height="10" viewBox="0 0 7 10" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.31812 9L5.68175 5L1.31812 1" stroke="white" stroke-width="2"
                                      stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </button>
                    </div>
                </div>
                <!--                    modal-->
                <div class="modal" id="modalSendResult">
                    <div class="modal__bg modal-exit"></div>

                    <div class="modal__container">
                        <button class="modal__close modal-exit">
                            <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.00081 14L14 1.00081M1 1L13.9992 13.9992" stroke="#232323" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </button>
                        <h3 class="modal__title">Send me my results</h3>
                        <div class="modal__body">
                            <div class="form-send">
                                <div class="form-send__input-box">
                                    <label for="email" class="form-send__label">Email address</label>
                                    <input id="email" type="email" class="form-send__input" name="email" placeholder="Enter your email">
                                </div>

                                <div class="form-send__input-box">
                                    <label for="name" class="form-send__label">Name</label>
                                    <input id="name" type="text" class="form-send__input" name="name" placeholder="Enter your name">
                                </div>

                                <div class="form-send__input-box">
                                    <label for="phone" class="form-send__label">Phone</label>
                                    <input id="phone" type="tel" class="form-send__input" name="phone" placeholder="Enter your phone">
                                </div>
                            </div>
                            <div class="form-send__status-ok hide">Success!</div>
                            <div class="form-send__status-fail hide">Error!</div>
                            <button type="submit" 
                            class="calc-wrp__btn-calc" 
                            data-text="Prequalify Now" 
                            data-wait="Loading..." 
                            data-success="Success!" 
                            data-error="Error!">
                            Send Now
                            <svg width="7" height="10" viewBox="0 0 7 10" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.31812 9L5.68175 5L1.31812 1" stroke="white" stroke-width="2"
                                      stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </form>`;

    calculatorWrp.insertAdjacentHTML("afterbegin", html);

    return true;
};

export default htmlTemplateForm;